Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.GoogleSearchContentFactory

  create: (socialContent, allTags) ->
    content = new Monitoring.Models.SocialContents.GoogleSearchContent(socialContent)
    return content

  canHandle: (socialContent) ->
    return socialContent.type == "google_search"
